export default {
  props: {
    path: {
      type: String
    },
    label: {
      type: String
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/back-link/back-link.js